<div class="ft2-app-menu-entry" (click)="showAppMenu($event)" [class.dark-text]="darkText">
    <small class="ft2-dialog-badge -arrow_right" *ngIf="($latestBadge | async) as latestBadge">
        {{latestBadge}}
    </small>
    <i class="ft-icn-dotmenu"></i>
</div>
